import { render } from "./ConfigurationRemoveAllChoicesDialog.vue?vue&type=template&id=706b733f"
import script from "./ConfigurationRemoveAllChoicesDialog.vue?vue&type=script&lang=js"
export * from "./ConfigurationRemoveAllChoicesDialog.vue?vue&type=script&lang=js"

import "./ConfigurationRemoveAllChoicesDialog.vue?vue&type=style&index=0&id=706b733f&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard});qInstall(script, 'directives', {ClosePopup});
